<template>
    <div class="management">
        <div v-if="showTitle" class="section-title">Управление</div>
        <div class="items">
            <button
                v-for="item in items"
                :key="item.id"
                type="button"
                class="item"
                :class="{ 'item--muted': item.muted }"
                :disabled="item.disabled"
                @click="onItemClick(item)"
            >
                <ChatIcon :name="item.icon" :size="14" />
                <span class="item-text">
                    <span class="item-title">
                        {{ item.title }}
                        <span v-if="item.badge" class="item-badge">{{ item.badge > 9 ? '9+' : item.badge }}</span>
                    </span>
                    <span v-if="item.subtitle" class="item-subtitle">{{ item.subtitle }}</span>
                </span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import ChatIcon from '@/components/chat/icons/ChatIcon.vue'

const props = defineProps({
    showTitle: { type: Boolean, default: true },
    isAuthenticated: { type: Boolean, default: false },
    isAdmin: { type: Boolean, default: false },
    supportUnread: { type: Number, default: 0 },
})

const emit = defineEmits(['open-my-shares', 'open-admin', 'open-support'])

const items = computed(() => {
    const list = [
        { id: 'reports', icon: 'folder', title: 'Мои отчёты', subtitle: 'Скоро', muted: true, disabled: true },
    ]
    if (props.isAuthenticated) {
        list.unshift({ id: 'shares', icon: 'link', title: 'Мои ссылки' })
        list.push({
            id: 'support',
            icon: 'bell',
            title: 'Обращения',
            subtitle: 'Поддержка',
            badge: props.supportUnread > 0 ? props.supportUnread : null,
        })
    }
    if (props.isAdmin) {
        list.push({ id: 'admin', icon: 'shield', title: 'Админ-раздел' })
    }
    list.push({ id: 'alerts', icon: 'bell', title: 'Алёрты и подписки', subtitle: 'Скоро', muted: true, disabled: true })
    return list
})

function onItemClick(item) {
    if (item.id === 'shares') emit('open-my-shares')
    else if (item.id === 'admin') emit('open-admin')
    else if (item.id === 'support') emit('open-support')
}
</script>

<style scoped>
.management {
    padding: 0 4px;
}

.section-title {
    font-size: 10.5px;
    font-weight: 600;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #888780;
    padding: 0 8px 6px;
}

.items {
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 7px 8px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    font-family: inherit;
    text-align: left;
    color: #23282C;
    cursor: pointer;
}

.item:hover {
    background: #F1EFE8;
}

.item--muted .item-title { color: #888780; }
.item--muted:hover { background: transparent; cursor: default; }
.item:disabled { cursor: default; }

.item-text {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
}

.item-title {
    font-size: 12.5px;
    color: #23282C;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.item-badge {
    min-width: 16px;
    height: 16px;
    padding: 0 5px;
    border-radius: 999px;
    background: #E30613;
    color: white;
    font-size: 10px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
}

.item-subtitle {
    font-size: 10.5px;
    color: #888780;
    margin-top: 1px;
}
</style>
